export default function( { children } ) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2">
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" aria-hidden="true"></div>

        <div className="relative bg-white w-full max-w-lg md:max-w-2xl lg:max-w-3xl p-3 rounded-lg shadow-lg max-h-[90vh] overflow-y-auto">
        {children}
        </div>
    </div>
  )
}